import { TabItem } from '@/types';

export const TAB_ITEMS: TabItem[] = [
  {
    id: 'default',
    title: '약속 잡기',
  },
  {
    id: 'result',
    title: '약속방',
  },
];
